import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  optons: [],
  columns: [
    {
      label: 'Name', field: 'name'
    },
    {
      label: 'Description', field: 'desc'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/article/categorys/status/AC'}
    useIPA.get(param).then(response => {
      const article = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...article})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/article/category/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        desc: formData.text_2
			}
      const param = { rawData: rawData, url: 'dashboard/master/article/category', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'article-category' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/article/category', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, article) {
    state.all = article.rows
    state.pages = article.pages
    state.options = []
    for (let i = 0; i < article.rows.length; i++) {
      const option = []
      for (const key in article.rows[i]) {
        if (key === 'id') { 
          option['value'] = article.rows[i][key] 
        } else if (key === 'name') { 
          option['title'] = article.rows[i][key] 
        } else if (key === 'id') { 
          option['oid'] = article.rows[i][key] 
        } 
      }
      state.options.push(Object.assign({}, option))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
